import React, { useState } from "react";
import classes from "./SubscriptionManagement.module.css";
import SideBarSkeleton from "@/components/Core/SideBarSkeleton";
import Box from "@/components/Box";
import { Button } from "@/components/Core/Button";
import TableStructure from "@/components/Core/TableStructure";
import Statuses from "@/components/Core/Statuses";
import PopperComponent from "@/components/Core/PopperComponent";
import SubscriptionCard from "@/components/SubscriptionCard";
import AddEditSubscriptionModal from "@/modals/addEditSubscriptionModal";
import { filterData } from "@/data/data";
import SearchInput from "@/components/Core/SearchInput";
import { FiEye } from "react-icons/fi";

function SubscriptionManagement() {
  const [data, setData] = useState(subscriptionTableContent);
  const [subscriptionData, setSubscriptionData] = useState(subscription_dummy);
  const [modal, setModal] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(30);
  const [filter, setFilter] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const popperClickHandler = (actionItem, rowData) => {
    switch (actionItem?.value) {
      case "view":
        break;
      default:
        break;
    }
  };

  return (
    <>
      <SideBarSkeleton>
        <div className={classes.container}>
          <Box>
            <div className={classes.header}>
              <p className={classes.pageHeading}>Subscription Management</p>
              <Button
                className={classes.addNewBtn}
                label="Add New"
                onClick={() => setModal("addEditSubscription")}
              />
            </div>
            <div className={classes.subscriptionCards}>
              {subscriptionData.map((item) => (
                <SubscriptionCard
                  data={item}
                  editClick={() => {
                    setSelectedItem(item);
                    setModal("addEditSubscription");
                  }}
                />
              ))}
            </div>
          </Box>
          <Box>
            <div className="subscriptionTable">
              <TableStructure
                headerHandlers={{
                  search: (
                    <div className={classes.search}>
                      <SearchInput value={search} setter={setSearch} />
                    </div>
                  ),
                  filter: (
                    <div className={classes.filter}>
                      <PopperComponent
                        handleClick={(actionItem) => {
                          setFilter(actionItem);
                        }}
                        data={filterData}
                      >
                        <Button
                          label={filter ? filter.label : "Filter"}
                          customStyle={{ height: "42px" }}
                        />
                      </PopperComponent>
                    </div>
                  ),
                }}
                tableHeaders={subscriptionTableHeaders}
                headerTitle="Subscription History"
                tableContent={data.map((item) => ({
                  ...item,
                  status: <Statuses status={item?.status} />,
                  action: (
                    <PopperComponent
                      data={[{ label: "View", value: "view", icon: <FiEye /> }]}
                      handleClick={(actionItem) =>
                        popperClickHandler(actionItem, item)
                      }
                    />
                  ),
                }))}
              />
            </div>
          </Box>
        </div>
      </SideBarSkeleton>
      <AddEditSubscriptionModal
        show={modal}
        setShow={setModal}
        data={selectedItem}
      />
    </>
  );
}

export default SubscriptionManagement;

const subscriptionTableHeaders = [
  { label: "user Name", value: "userName" },
  { label: "Subscription Plan", value: "subscriptionPlan" },
  { label: "Subscription Date", value: "subscriptionDate" },
  { label: "Expiry Date", value: "expiryDate" },
  { label: "Payment Method", value: "paymentMethod" },
  { label: "Status", value: "status" },
  { label: "", value: "action" },
];

const subscriptionTableContent = Array(10)
  .fill("")
  .map((_, index) => ({
    userName: "Name here",
    subscriptionPlan: "Premium",
    subscriptionDate: Date.now(),
    expiryDate: Date.now(),
    paymentMethod: "Credit Card",
    status: ["active", "expired", "pending"][index % 3],
  }));

const subscription_dummy = Array(3)
  .fill("")
  .map((_, index) => ({
    name: ["Standard", "Professional", "Premium"][index % 3],
    price: [10, 39, 52][index % 3],
    description: "Lorem ipsum dolor sit amet",
    benefits: ["Lorem ipsum", "Lorem ipsum", "Lorem ipsum", "Lorem ipsum"],
  }));
